import * as colors from '@giphy/colors'
import { TitleLarge } from 'shared/components/text-elements'
import styled from 'styled-components'

export default styled(TitleLarge)`
    margin-bottom: 8px;

    &:before {
        background: no-repeat url(${(props) => props.icon}) center center ${colors.giphyBlack};
        background-size: cover;
        border-radius: 8px;
        content: '';
        display: inline-block;
        height: 40px;
        margin: -6px 10px 0 0;
        vertical-align: middle;
        width: 40px;
    }
`
